/* MMG / Kairos Concierge text-only fresh-session compatibility runtime v4.0.0. */
(function () {
  'use strict';

  if (window.__MMG_KAIROS_CONCIERGE_SESSION_V400__) return;
  window.__MMG_KAIROS_CONCIERGE_SESSION_V400__ = true;

  var CLEAR_WINDOW_MS = 850;
  var PANEL_SELECTORS = ['#kairos-concierge-panel','[data-kairos-concierge-panel]','[data-mmg-kairos-panel]'];
  var STREAM_SELECTORS = ['[data-kairos-messages]','[data-kairos-transcript]','.kc-messages','.kc-thread','.kc-chat-log','.kc-conversation','.kc-log','[role="log"]'];
  var MESSAGE_SELECTORS = ['[data-kairos-message]','[data-message-id]','.kc-message','.kc-msg','[data-role="assistant"]','[data-role="user"]','[data-author="assistant"]','[data-author="user"]'];

  var state = {
    panel: null,
    open: false,
    sessionId: '',
    clearUntil: 0,
    userEngaged: false,
    scanQueued: false
  };

  function uuid() {
    try { if (crypto && typeof crypto.randomUUID === 'function') return crypto.randomUUID(); } catch (_) {}
    return 'kairos-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }

  function visible(el) {
    if (!(el instanceof HTMLElement)) return false;
    var style = getComputedStyle(el);
    var rect = el.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) !== 0 && rect.width > 0 && rect.height > 0;
  }

  function findPanel() {
    for (var i = 0; i < PANEL_SELECTORS.length; i += 1) {
      var direct = document.querySelector(PANEL_SELECTORS[i]);
      if (direct && visible(direct)) return direct;
    }
    var fields = document.querySelectorAll('input,textarea');
    for (var f = 0; f < fields.length; f += 1) {
      if ((fields[f].getAttribute('placeholder') || '').toLowerCase().indexOf('ask kairos') === -1) continue;
      var node = fields[f];
      for (var depth = 0; node && node !== document.body && depth < 12; depth += 1, node = node.parentElement) {
        if (!(node instanceof HTMLElement) || !visible(node)) continue;
        var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
        var rect = node.getBoundingClientRect();
        if (/kairos concierge/i.test(text) && rect.width > 240 && rect.height > 260) return node;
      }
    }
    return null;
  }

  function findInput(panel) {
    if (!panel) return null;
    return panel.querySelector('textarea,input[placeholder*="Kairos" i],input[type="text"],input:not([type])');
  }

  function stream(panel) {
    if (!panel) return null;
    for (var i = 0; i < STREAM_SELECTORS.length; i += 1) {
      var candidate = panel.querySelector(STREAM_SELECTORS[i]);
      if (candidate) return candidate;
    }
    return null;
  }

  function clearVisibleTranscript(panel) {
    if (!panel) return;
    var target = stream(panel) || panel;
    var messages = Array.from(target.querySelectorAll(MESSAGE_SELECTORS.join(','))).filter(function (node) {
      if (!(node instanceof HTMLElement)) return false;
      if (node.closest('form') || node.querySelector('textarea,input,form')) return false;
      if (node.closest('[data-mmg-kairos-preserve="true"]')) return false;
      return true;
    });
    messages.forEach(function (node) { node.remove(); });
    panel.dataset.mmgKairosFreshSession = messages.length ? 'cleared' : 'clean';
  }

  function resetInput(panel) {
    var input = findInput(panel);
    if (!input) return;
    try {
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (_) {}
  }

  function clearTranscriptStorage() {
    [window.localStorage, window.sessionStorage].forEach(function (storage) {
      if (!storage) return;
      var keys = [];
      try {
        for (var i = 0; i < storage.length; i += 1) {
          var key = storage.key(i) || '';
          var lower = key.toLowerCase();
          if (lower.indexOf('kairos') === -1) continue;
          if (/(auth|token|customer|consent)/.test(lower)) continue;
          if (/(history|conversation|transcript|messages|thread)/.test(lower)) keys.push(key);
        }
        keys.forEach(function (key) { storage.removeItem(key); });
      } catch (_) {}
    });
  }

  function startFreshSession(panel) {
    clearTranscriptStorage();
    state.panel = panel;
    state.sessionId = uuid();
    state.userEngaged = false;
    state.clearUntil = Date.now() + CLEAR_WINDOW_MS;
    panel.dataset.mmgKairosSessionId = state.sessionId;
    panel.dataset.mmgKairosSessionMode = 'fresh';
    window.__MMG_KAIROS_ACTIVE_SESSION_ID__ = state.sessionId;
    clearVisibleTranscript(panel);
    resetInput(panel);
    [40,120,280,520,820].forEach(function (delay) {
      setTimeout(function () {
        if (!state.sessionId || state.userEngaged || Date.now() > state.clearUntil) return;
        clearVisibleTranscript(panel);
        resetInput(panel);
      }, delay);
    });
    document.dispatchEvent(new CustomEvent('mmg:kairos:session:start', { detail: { sessionId: state.sessionId, fresh: true } }));
  }

  function endSession(panel) {
    var ended = state.sessionId;
    if (panel) {
      clearVisibleTranscript(panel);
      resetInput(panel);
      panel.removeAttribute('data-mmg-kairos-session-id');
      panel.dataset.mmgKairosSessionMode = 'ended';
    }
    clearTranscriptStorage();
    state.panel = null;
    state.sessionId = '';
    state.userEngaged = false;
    state.clearUntil = 0;
    try { delete window.__MMG_KAIROS_ACTIVE_SESSION_ID__; } catch (_) { window.__MMG_KAIROS_ACTIVE_SESSION_ID__ = ''; }
    document.dispatchEvent(new CustomEvent('mmg:kairos:session:end', { detail: { sessionId: ended } }));
  }

  function scan() {
    state.scanQueued = false;
    var panel = findPanel();
    var isOpen = !!panel;
    if (isOpen && !state.open) startFreshSession(panel);
    else if (!isOpen && state.open) endSession(state.panel);
    else if (isOpen) state.panel = panel;
    state.open = isOpen;
  }

  function scheduleScan() {
    if (state.scanQueued) return;
    state.scanQueued = true;
    requestAnimationFrame(scan);
  }

  function markEngaged(event) {
    if (!state.panel || !state.panel.contains(event.target)) return;
    state.userEngaged = true;
    state.clearUntil = 0;
  }

  document.addEventListener('input', markEngaged, true);
  document.addEventListener('submit', markEngaged, true);
  document.addEventListener('click', function (event) {
    if (state.panel && state.panel.contains(event.target) && event.target.closest('.kc-chip,.kc-send')) markEngaged(event);
    setTimeout(scheduleScan, 0);
    setTimeout(scheduleScan, 180);
  }, true);
  document.addEventListener('shopify:section:load', scheduleScan);
  window.addEventListener('pageshow', scheduleScan);
  window.addEventListener('beforeunload', function () { if (state.sessionId) endSession(state.panel); });

  if ('MutationObserver' in window) {
    new MutationObserver(scheduleScan).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class','style','hidden','aria-hidden','data-open']
    });
  }

  clearTranscriptStorage();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleScan, { once: true });
  else scheduleScan();
  window.setTimeout(scheduleScan, 400);
  window.setTimeout(scheduleScan, 1200);
})();
